import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  Autocomplete,
  Modal,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
} from '@mui/material';
import {
  Breadcrumb,
  CTSinput,
  CTSRinput,
  StyledTableCell,
  StyledTableRow,
} from '../../reusableComponent/Reusables';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { Print } from '@mui/icons-material';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
import customermaster from '../../../services/masters/customerMaster.Service';
import Delivery_akwonledgment from '../../../services/report/Delivery_akwonledgment';
import { useSelector } from 'react-redux';

const printStyles = `
  .print-header {
    display: none; /* Hidden on screen */
  }
  @media print {
    body * {
      visibility: hidden;
    }
    .printable-area, .printable-area * {
      visibility: visible;
    }
    .printable-area {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
    .no-print {
      display: none !important;
    }
    .printable-table {
      width: 100%;
      border-collapse: collapse;
      page-break-inside: auto; /* Allow table to break across pages naturally */
    }
    .printable-table th, .printable-table td {
      padding: 8px;
      font-size: 12px;
      page-break-inside: avoid; /* Prevent breaking inside table cells */
      page-break-after: auto;
    }
    .printable-image {
      max-width: 80px;
      max-height: 80px;
      object-fit: cover;
      vertical-align: middle;
      page-break-inside: avoid;
    }
    .print-header {
      display: block; /* Visible when printing */
      text-align: left;
      margin-bottom: 20px;
    }
    .print-header h1 {
      font-size: 20px ;
      margin: 0 0 10px 0;
    }
    .print-header .inline-details {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      gap: 20px;
      font-size: 14px;
    }
    .printable-table-container {
      max-height: none !important;
      height: auto !important;
      overflow: visible !important; /* Ensure no scrolling */
      page-break-inside: auto; /* Allow breaking across pages */
    }
    /* Ensure table rows and cells don't cause scrolling */
    .printable-table tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    /* Remove any default browser margins or overflows */
    body, html {
      margin: 0;
      padding: 0;
      overflow: visible !important;
    }
  }
`;

const Deliveryacknowledgemet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state || null;

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const depot_id = userInfo.depot_id;
  const plant_id = userInfo.plant_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

  const [successMessage, setSuccessMessage] = useState('');
  const [displayData, setDisplayData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [openDetail, setOpenDetail] = useState(false);
  const [dialogData, setDialogData] = useState([]);
  const [dialogTitle, setDialogTitle] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [printTimestamp, setPrintTimestamp] = useState('');

  const defaultRowsPerPage = useSelector(state => state.eci.rows_per_page || 15);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const allCustomersOption = { cust_id: 'all', cust_name: 'All' };
  const customerOptions = [allCustomersOption, ...customers];

  const { control, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: {
      entry_date_from: editData?.entry_date
    ? dayjs(editData.entry_date).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD"),        // ← today
  entry_date_to: dayjs().format("YYYY-MM-DD"),
      customer: editData?.customer || '',
    },
    resolver: async (data) => {
      const errors = {};
      if (!data.entry_date_from) errors.entry_date_from = { message: 'From Date is required' };
      if (!data.entry_date_to) errors.entry_date_to = { message: 'To Date is required' };
      if (data.entry_date_from && data.entry_date_to && dayjs(data.entry_date_to).isBefore(dayjs(data.entry_date_from))) {
        errors.entry_date_to = { message: 'To Date cannot be before From Date' };
      }
      return { values: data, errors };
    },
  });

  const entryDateFrom = watch('entry_date_from');
  const entryDateTo = watch('entry_date_to');
  const selectedCustomer = watch('customer');

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const [customerData] = await Promise.all([
          customermaster.getCustomerList({ page: 0, size: 999, searchKey: '' }),
        ]);
        setCustomers(customerData || []);
      } catch (error) {
        console.error('Data fetching failed', error);
        setSuccessMessage('Error fetching customer data');
        setCustomers([]);
      } finally {
        setLoading(false);
      }
    }
    fetchData();

    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const fetchData = async (formData, page, rowsPerPage) => {
    try {
      setLoading(true);
      setDisplayData([]);

      const filterParams = {
        page,
        size: rowsPerPage,
        searchKey: '',
        from_date: formData.entry_date_from,
        to_date: formData.entry_date_to,
        customer_id: formData.customer === 'all' ? '' : formData.customer || '',
      };

      const response = await Delivery_akwonledgment.DeliveryakwnoledgmentreportList(filterParams);
      const fetchedData = response?.data || response || [];
      const total = response?.total_count || fetchedData.length || 0;

      const flattenedData = fetchedData.map((item, index) => {
        let images = [];
        try {
          images = typeof item.upload_receipt === 'string' ? JSON.parse(item.upload_receipt) : item.upload_receipt || [];
        } catch (error) {
          console.error('Error parsing upload_receipt:', error);
          images = [];
        }

        return {
          sr_no: page * rowsPerPage + index + 1,
          date: dayjs(item.date).format('YYYY-MM-DD'),
          cust_name: item.name_of_customer || 'N/A',
          cylinder_code: item.cylinder_code || 'N/A',
          prod_code: item.prod_code || 'N/A',
          prod_name: item.prod_name || 'N/A',
          ecr_no: item.ecr_no || 'N/A',
          vehicle_no: item.vehicle_no || 'N/A',
          receiving_depot: item.receiving_depot || 'N/A',
          no_of_cylinders: item.no_of_cylinders || 0,
          images: images,
          cylinders: item.cylinders || [],
        };
      });

      const filteredData = formData.customer && formData.customer !== 'all'
        ? flattenedData.filter(row => row.cust_name === customers.find(c => c.cust_id === formData.customer)?.cust_name)
        : flattenedData;

      setDisplayData(filteredData);
      setTotalCount(total);
      setPrintTimestamp(new Date().toLocaleString());
    } catch (error) {
      console.error('Error fetching data for display:', error);
      setSuccessMessage(error.response?.data?.message || 'Error fetching report data');
      setDisplayData([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleShow = (formData) => {
    setController(prev => ({ ...prev, page: 0 }));
    fetchData(formData, 0, controller.rowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setController(prev => ({ ...prev, page: newPage }));
    fetchData(
      {
        entry_date_from: entryDateFrom,
        entry_date_to: entryDateTo,
        customer: watch('customer'),
      },
      newPage,
      controller.rowsPerPage
    );
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setController({
      page: 0,
      rowsPerPage: newRowsPerPage,
    });
    fetchData(
      {
        entry_date_from: entryDateFrom,
        entry_date_to: entryDateTo,
        customer: watch('customer'),
      },
      0,
      newRowsPerPage
    );
  };

  const handlePrint = () => {
    window.print();
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage('');
  };

  const handleCylinderClick = (row) => {
    setDialogData(row.cylinders || []);
    setDialogTitle(`Cylinder Details for ECR No: ${row.ecr_no}`);
    setOpenDetail(true);
  };

  const handleClose = () => {
    setOpenDetail(false);
    setDialogData([]);
    setDialogTitle('');
  };

  const dateConversion = (date) => {
    if (!date) return 'N/A';
    const today = new Date(date);
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const getCustomerName = () => {
    if (!selectedCustomer || selectedCustomer === 'all') return 'All';
    return customers.find(c => c.cust_id === selectedCustomer)?.cust_name || 'N/A';
  };

  return (
    <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: 'DELIVERY ACKNOWLEDGMENT REPORT' }]} className="no-print" />
        <Typography className={`${styles.header_txt} no-print`}>DELIVERY ACKNOWLEDGMENT REPORT</Typography>

        <form onSubmit={handleSubmit(handleShow)} className="no-print">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography className={styles.label_Txt_add}>From Date</Typography>
                <Controller
                  name="entry_date_from"
                  control={control}
                  rules={{ required: 'From Date is required' }}
                  render={({ field }) => (
                    <CTSRinput
                      size="small"
                      fullWidth
                      type="date"
                      {...field}
                      error={!!errors.entry_date_from}
                      helperText={errors.entry_date_from?.message}
                      InputProps={{ className: styles.CTSinput_Box }}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography className={styles.label_Txt_add}>To Date</Typography>
                <Controller
                  name="entry_date_to"
                  control={control}
                  rules={{ required: 'To Date is required' }}
                  render={({ field }) => (
                    <CTSRinput
                      size="small"
                      fullWidth
                      type="date"
                      {...field}
                      error={!!errors.entry_date_to}
                      helperText={errors.entry_date_to?.message}
                      InputProps={{ className: styles.CTSinput_Box }}
                    />
                  )}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4.5}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography className={styles.label_Txt_add}>Customer</Typography>
                {loading ? (
                  <Typography>Loading...</Typography>
                ) : (
                  <Controller
                    name="customer"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        disablePortal
                        options={customerOptions}
                        getOptionLabel={(option) => option.cust_name || ''}
                        isOptionEqualToValue={(option, value) => option.cust_id === value.cust_id}
                        value={customerOptions.find((c) => c.cust_id === field.value) || null}
                        onChange={(_, value) => field.onChange(value ? value.cust_id : '')}
                        loading={loading}
                        renderOption={(props, option) => (
                          <li {...props} className={styles.cts_label}>
                            {option.cust_name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <CTSinput
                            {...params}
                            placeholder="Select or type a customer"
                            variant="outlined"
                            size="small"
                            fullWidth
                            error={!!errors.customer}
                            helperText={errors.customer?.message}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              ...params.InputProps,
                              className: styles.CTSinput_Box,
                            }}
                          />
                        )}
                        sx={{ width: '100%' }}
                      />
                    )}
                  />
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={1.5}>
              <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <Button
                  variant="contained"
                  startIcon={<VisibilityIcon />}
                  type="submit"
                  className={`${styles.addnew_btn}`}
                  disabled={loading}
                >
                  <Typography className={`${styles.addnew_btn_txt}`}>Show</Typography>
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>

        <Box className="printable-area">
          <Box className="print-header">
            <Typography variant="h1" sx={{fontWeight:'bold'}}>DELIVERY ACKNOWLEDGMENT REPORT</Typography>
            <Box className="inline-details">
              <Typography variant="body1">From Date: {dateConversion(entryDateFrom)}</Typography>
              <Typography variant="body1">To Date: {dateConversion(entryDateTo)}</Typography>
              <Typography variant="body1">Customer: {getCustomerName()}</Typography>
            </Box>
          </Box>

          <Grid item xs={12} sx={{ mt: 4 }}>
            <Paper sx={{ width: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  padding: '10px',
                }}
                className="no-print"
              >
                {displayData.length > 0 && (
                  <Button
                    style={{ float: 'right', cursor: 'pointer' }}
                    variant="outlined"
                    startIcon={<Print />}
                    onClick={handlePrint}
                  >
                    Print
                  </Button>
                )}
              </Box>
              <TableContainer component={Paper} className={`${styles.list_tbl_container} printable-table-container printable-table`}>
                <Table size="small" stickyHeader className="printable-table">
                  <TableHead className={styles.table_head_container}>
                    <StyledTableRow>
                      <StyledTableCell align="center">Sr No</StyledTableCell>
                      <StyledTableCell align="left">Date</StyledTableCell>
                      <StyledTableCell align="left">Customer Name</StyledTableCell>
                      <StyledTableCell align="left">Product Code</StyledTableCell>
                      <StyledTableCell align="left">Product Description</StyledTableCell>
                      <StyledTableCell align="left">ECR No</StyledTableCell>
                      <StyledTableCell align="left">No Of Cylinder</StyledTableCell>
                      <StyledTableCell align="left">Vehicle No</StyledTableCell>
                      <StyledTableCell align="left">Depot</StyledTableCell>
                      <StyledTableCell align="left">Images</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#fff' }}>
                    {loading ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={10} align="center">
                          <Typography>Loading data...</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : displayData.length === 0 ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={10} align="center">
                          <Typography>No data found</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      displayData.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="center" className={styles.inspection_cell}>{row.sr_no}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{dateConversion(row.date)}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.cust_name}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.prod_code}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.prod_name}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.ecr_no}</StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={styles.inspection_cell}
                            sx={{ cursor: row.no_of_cylinders > 0 ? 'pointer' : 'default', color: row.no_of_cylinders > 0 ? '#1976d2' : 'inherit' }}
                            onClick={() => row.no_of_cylinders > 0 && handleCylinderClick(row)}
                          >
                            {row.no_of_cylinders}
                          </StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.vehicle_no}</StyledTableCell>
                          <StyledTableCell className={styles.inspection_cell}>{row.receiving_depot}</StyledTableCell>
                          <StyledTableCell>
                            {row.images.length > 0 ? (
                              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                {row.images.map((image, imgIndex) => (
                                  <img
                                    key={imgIndex}
                                    src={image}
                                    alt={`Receipt ${imgIndex + 1}`}
                                    className="printable-image"
                                    style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                    onClick={() => handleImageClick(image)}
                                    onError={(e) => {
                                      e.target.src = '/assets/fallback-image.jpg';
                                    }}
                                  />
                                ))}
                              </Box>
                            ) : (
                              'No images'
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={controller.rowsPerPage}
                page={controller.page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                className="no-print"
              />
            </Paper>
          </Grid>
        </Box>

        <Dialog
          PaperProps={{
            sx: {
              minWidth: '90%',
              maxHeight: '90%',
            },
          }}
          onClose={handleClose}
          open={openDetail}
          className="no-print"
        >
          <DialogTitle id="customized-dialog-title">
            {dialogTitle}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
              <Table size="small" stickyHeader>
                <TableHead className={styles.table_head_container}>
                  <StyledTableRow>
                    <StyledTableCell align="center">Sr No</StyledTableCell>
                    <StyledTableCell align="left">Cylinder No</StyledTableCell>
                    <StyledTableCell align="left">Tag No</StyledTableCell>
                    <StyledTableCell align="left">Owner</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: '#fff' }}>
                  {dialogData.length > 0 ? (
                    dialogData.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell align="center">{index + 1}</StyledTableCell>
                        <StyledTableCell className={styles.inspection_cell}>
                          {row.cylinder_no || '-'}
                        </StyledTableCell>
                        <StyledTableCell className={styles.inspection_cell}>
                          {row.tag_no || '-'}
                        </StyledTableCell>
                        <StyledTableCell className={styles.inspection_cell}>
                          {row.owner || '-'}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={4} align="center">
                        No cylinder details available
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={() => setSuccessMessage('')}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
          className="no-print"
        />

        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="image-modal-title"
          aria-describedby="image-modal-description"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          className="no-print"
        >
          <Box
            sx={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <IconButton
              sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
              onClick={handleCloseModal}
            >
              <CloseIcon />
            </IconButton>
            <img
              src={selectedImage}
              alt="Full-size receipt"
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                objectFit: 'contain',
              }}
              onError={(e) => {
                e.target.src = '/assets/fallback-image.jpg';
              }}
            />
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};

export default Deliveryacknowledgemet;